<div [@routerTransition]>
    <sub-header [title]="'Customers' | localize" [description]="'CustomersHeaderInfo' | localize">
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button
                    id="dropdownButtonExcelOperations"
                    dropdownToggle
                    type="button"
                    class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="dropdownMenuExcelOperations"
                >
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul
                    id="dropdownMenuExcelOperations"
                    class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu"
                    *dropdownMenu
                    aria-labelledby="dropdownButtonExcelOperations"
                >
                    <li role="menuitem">
                        <a
                            class="dropdown-item text-gray-900"
                            id="ExportCustomersToExcelButton"
                            (click)="this.showExcelColumnSelectionModal()"
                            href="javascript:;"
                        >
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <li *ngIf="'Pages.Customers.Create' | permission" role="menuitem">
                        <a href="javascript:;" class="no-padding">
                            <span class="fileinput-button">
                                <p-fileUpload
                                    mode="basic"
                                    customUpload="true"
                                    name="ExcelFileUpload"
                                    #ExcelFileUpload
                                    maxFileSize="10000000"
                                    auto="auto"
                                    accept=".csv,.xls,.xlsx"
                                    (uploadHandler)="uploadExcel($event)"
                                    (onError)="onUploadExcelError()"
                                    chooseLabel="{{ 'ImportFromExcel' | localize }}"
                                ></p-fileUpload>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <button
                id="btn_create_customer"
                *ngIf="'Pages.Customers.Create' | permission"
                (click)="createCustomer()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewCustomer') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input
                                            [(ngModel)]="filterText"
                                            (ngModelChange)="getCustomers()"
                                            name="filterText"
                                            autoFocus
                                            type="text"
                                            class="form-control"
                                            [placeholder]="l('SearchWithThreeDot')"
                                        />
                                        <button class="btn btn-primary" type="submit" (click)="getCustomers()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>

                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="PaymentTermNameFilter">
                                        ({{ l('PaymentTerm') }}) {{ l('Name') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="PaymentTermNameFilter"
                                        name="paymentTermNameFilter"
                                        [(ngModel)]="paymentTermNameFilter"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="PriceGroupNameFilter">
                                        ({{ l('PriceGroup') }}) {{ l('Name') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="PriceGroupNameFilter"
                                        name="priceGroupNameFilter"
                                        [(ngModel)]="priceGroupNameFilter"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="LocationNameFilter">
                                        ({{ l('Location') }}) {{ l('Name') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="LocationNameFilter"
                                        name="locationNameFilter"
                                        [(ngModel)]="locationNameFilter"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="CurrencyNameFilter">
                                        ({{ l('Currency') }}) {{ l('Name') }}
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="CurrencyNameFilter"
                                        name="currencyNameFilter"
                                        [(ngModel)]="currencyNameFilter"
                                    />
                                </div>
                            </div>
                            <div class="col-md-12 mt-5">
                                <button
                                    (click)="resetFilters()"
                                    class="btn btn-secondary btn-sm"
                                    id="btn-reset-filters"
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-12">
                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="!advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-down"></i>
                                    {{ l('ShowAdvancedFilters') }}
                                </span>

                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-up"></i>
                                    {{ l('HideAdvancedFilters') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getCustomers($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th
                                        style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.Customers.Edit', 'Pages.Customers.Delete')"
                                    >
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="customerCode">
                                        {{ l('CustomerCode') }}
                                        <p-sortIcon field="customer.customerCode"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="name">
                                        {{ l('Name') }}
                                        <p-sortIcon field="customer.name"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="address1">
                                        {{ l('Address1') }}
                                        <p-sortIcon field="customer.address1"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="address2">
                                        {{ l('Address2') }}
                                        <p-sortIcon field="customer.address2"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="phoneNo">
                                        {{ l('PhoneNo') }}
                                        <p-sortIcon field="customer.phoneNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="balanceAmount">
                                        {{ l('BalanceAmount') }}
                                        <p-sortIcon field="customer.balanceAmount"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="priceGroupFk.name">
                                        {{ l('PriceGroup') }}
                                        <p-sortIcon field="priceGroupName"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="isTaxExempt">
                                        {{ l('IsTaxExempt') }}
                                        <p-sortIcon field="customer.isTaxExempt"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td
                                        style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.Customers.Edit', 'Pages.Customers.Delete')"
                                    >
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a
                                                        *ngIf="permission.isGranted('Pages.Customers.Edit')"
                                                        class="dropdown-item"
                                                        [routerLink]="['/app/sales/customers/createOrEdit']"
                                                        [queryParams]="{ id: record.customer.id }"
                                                    >
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        class="dropdown-item"
                                                        href="javascript:;"
                                                        *ngIf="permission.isGranted('Pages.Customers.Delete')"
                                                        (click)="deleteCustomer(record.customer)"
                                                    >
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('CustomerCode') }}</span>
                                        {{ record.customer.customerCode }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Name') }}</span>
                                        {{ record.customer.name }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Address1') }}</span>
                                        {{ record.customer.address1 }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Address2') }}</span>
                                        {{ record.customer.address2 }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('PhoneNo') }}</span>
                                        {{ record.customer.phoneNo }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('BalanceAmount') }}</span>
                                        {{ record.customer.balanceAmount }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.priceGroupName }}
                                    </td>

                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('IsTaxExempt') }}</span>

                                        <div *ngIf="record.customer.isTaxExempt" class="text-center">
                                            <i class="fa fa-check-circle text-success" title="True"></i>
                                        </div>

                                        <div *ngIf="!record.customer.isTaxExempt" class="text-center">
                                            <i class="fa fa-times-circle" title="False"></i>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getCustomers($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal
        (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal
    ></excel-column-selection-modal>
</div>
